// Functions

// Bundle Product Form Append Start
function createHiddenInput(name, value, className) {
    let input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    if (className) {
        input.setAttribute('class', className);
    }
    return input;
}

function appendProductInputs(formElement, productId, planId) {
    let baseName = 'items[1]';
    formElement.appendChild(createHiddenInput(`${baseName}[id]`, productId, 'ProductInput'));
    formElement.appendChild(createHiddenInput(`${baseName}[quantity]`, '1', 'ProductInput'));
    formElement.appendChild(createHiddenInput(`${baseName}[selling_plan]`, planId, 'ProductInput'));
}
// Bundle Product Form Append End

document.addEventListener('DOMContentLoaded', () => {

    // Product Sticky Add To Cart Animation Start

    var ProductStickyAddToBag = document.querySelector('.ProductStickyAddToBag');
    if (ProductStickyAddToBag) {
        ProductStickyAddToBag.classList.remove("Disable");
        ProductStickyAddToBag.classList.add("FadeInAnimation");
    }

    // Product Sticky Add To Cart Animation End
    // Thumbnail Swiper
    const thumbsSwiper = new Swiper(".thumbs-slider", {
        direction: "vertical",
        spaceBetween: 12,
        slidesPerView: 6,
        watchOverflow: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,

        navigation: {
            nextEl: ".thumbs-next",
            prevEl: ".thumbs-prev",
        },
    });


    // Main Product Gallery
    const mainSwiper = new Swiper(".ProductMainGallery", {
        slidesPerView: 1,
        loop: false,

        lazy: {
            loadPrevNext: true,
        },

        zoom: {
            maxRatio: 2,
        },

        hashNavigation: {
            watchState: true
        },

        thumbs: {
            swiper: thumbsSwiper
        },

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });

    function loadAndPlayActiveVideo(swiper) {
        swiper.slides.forEach(s => {
            const v = s.querySelector('video');
            if (v) v.pause();
        });
        const active = swiper.slides[swiper.activeIndex];
        if (!active) return;
        const video = active.querySelector('video');
        if (!video) return;
        if (!video.src && video.dataset.src) {
            video.src = video.dataset.src;
            video.load();
        }
        video.play().catch(() => {});
    }

    mainSwiper.on('slideChange', function () {
        loadAndPlayActiveVideo(this);
    });
    loadAndPlayActiveVideo(mainSwiper);

    mainSwiper.on('activeIndexChange', function () {
        this.pagination.render();
        this.pagination.update();
    });


        // Manual button disable logic (fixed total slides count)
        mainSwiper.on('slideChangeTransitionEnd', function () {

            const currentSlideIndex = mainSwiper.realIndex;
            const totalSlides = mainSwiper.slides.length - mainSwiper.loopedSlides * 2;

            const prevButton = document.querySelector('.swiper-button-prev');
            const nextButton = document.querySelector('.swiper-button-next');

            if (prevButton) {
                prevButton.classList.toggle('swiper-button-disabled', currentSlideIndex === 0);
            }

            if (nextButton) {
                nextButton.classList.toggle('swiper-button-disabled', currentSlideIndex === totalSlides - 1);
            }
        });


    // Product Gallery Slider End


    // Product Rightbar Variation Start
    var section = document.getElementById('rightBar');
    if (section) {
        var productType = section.getAttribute('data-type');

        if (productType === 'bundle') {

            var productOptions = document.querySelectorAll('.ProductButton');
            var singleButton = document.querySelector('.ProductButton[data-variant="single"]');
            var stickyPriceElement = document.querySelector('.sticky-product-price');
            var stickyTitleElement = document.querySelector('.sticky-product-title');
            var originalPrice = stickyPriceElement.textContent;

            var addToBagMobile = document.querySelector('.add-to-bag-mobile');
            var addToBagMobileRefurb = document.querySelector('.add-to-bag-mobile-refurb');
            var addToCartForm = document.querySelector('.add-to-cart-form');
            var addToCartFormMobile = document.querySelector('.add-to-cart-form-mobile');
            var addToCartFormRefurb = document.querySelector('.add-to-cart-form-refurb');
            var addToCartFormRefurbMobile = document.querySelector('.add-to-cart-form-mobile-refurb-mobile');

            var singleDescription = document.querySelector('.ProductDescriptionSingle');
            var bundleDescription = document.querySelector('.ProductDescriptionBundle');

            var singleTitleElement = document.querySelector('.RightbarProductSingleName');
            var bundleTitleElement = document.querySelector('.RightbarProductBundleName');
            var refurbTitleElement = document.querySelector('.RightbarProductRefurbName');
            var refurbBundleTitleElement = document.querySelector?.('.RightbarProductRefurbBundleName');

            var refurbBundlePriceElement = document.querySelector('.RightbarProductRefurbBundlePrice');
            var refurbPriceElement = document.querySelector('.RightbarProductRefurbSinglePrice');
            var singlePriceElement = document.querySelector('.RightbarProductSinglePrice');
            var bundlePriceElement = document.querySelector('.RightbarProductBundlePrice');

            var ProductStickyRefurbBundlePriceWrapper = document.querySelector('.ProductStickyRefurbBundlePriceWrapper');
            var ProductStickySinglePriceWrapper = document.querySelector('.ProductStickySinglePriceWrapper');
            var ProductStickyBundlePriceWrapper = document.querySelector('.ProductStickyBundlePriceWrapper');
            var ProductStickyRefurbSinglePriceWrapper = document.querySelector('.ProductStickyRefurbSinglePriceWrapper');

            var affirm = document.querySelector('.AffirmContainerMLM');
            var affirmRefurb = document.querySelector('.AffirmContainerRefurb');

            productOptions.forEach(button => {

                button.addEventListener('click', function (event) {
                    productOptions.forEach(node => {
                        node.classList.remove('active');
                    });
                    this.classList.add('active');

                    let variant = this.getAttribute('data-variant');

                    // Rightbar click and swiper updated code start
                    let slides = document.querySelectorAll('.ProductMainGallery .swiper-slide');

                    slides.forEach(slide => {

                        let img = slide.querySelector('img');
                        let video = slide.querySelector('video');

                        let matchVariant = (element, variant) => {
                            return element.getAttribute('data-variant') === variant ||
                                element.getAttribute('data-variant') === 'both' ||
                                (variant === 'refurbsingle' && element.getAttribute('data-variant') === 'single') ||
                                (variant === 'refurbbundle' && element.getAttribute('data-variant') === 'bundle') ||
                                element.getAttribute('data-variant') === 'default';
                        };

                        if ((img && matchVariant(img, variant)) || (video && matchVariant(video, variant))) {
                            slide.style.display = 'flex';
                        } else {
                            slide.style.display = 'none';
                        }
                    });
                    swiper.update();
                    // Rightbar click and swiper updated code End


                    // Rightbar Infos text Start
                    var productInfo = document.querySelectorAll('.productInfo');
                    productInfo.forEach(info => {
                        let dataVariant = info.getAttribute('data-variant');

                        if (dataVariant === 'both' || dataVariant === variant) {
                            info.style.display = 'flex';
                        } else {
                            info.style.display = 'none';
                        }
                    });
                    // Rightbar Infos text End

                    /*let url = new URL(window.location.href);
                    url.searchParams.set('variant', variant);
                    window.history.pushState({path: url.href}, '', url.href);*/

                    let titleSingle = this.getAttribute('data-title-single');
                    let titleBundle = this.getAttribute('data-title-bundle');
                    let titleRefurb = this.getAttribute('data-title-refurb');
                    let titleRefurbBundle = this.getAttribute('data-title-refurb-bundle');
                    let productId = this.getAttribute('data-product-id');
                    let productSingleId = this.getAttribute('data-single-id');
                    let planId = this.getAttribute('data-selling-plan-id');
                    let bundlePrice = this.getAttribute('data-price');

                    if (variant === 'single') {
                        affirmRefurb.classList.add("Disable");
                        bundlePriceElement.classList.add('Disable');
                        addToCartFormRefurb.classList.add("Disable")
                        addToCartFormRefurbMobile.classList.add("Disable");
                        ProductStickyBundlePriceWrapper.classList.add('Disable');
                        bundleDescription.classList.add('Disable');
                        ProductStickyRefurbBundlePriceWrapper.classList.add('Disable');
                        refurbPriceElement.classList.add('Disable');
                        refurbTitleElement.classList.add('Disable');
                        bundleTitleElement.classList.add('Disable');
                        ProductStickyRefurbSinglePriceWrapper.classList.add('Disable');
                        refurbBundleTitleElement.classList.add('Disable');
                        refurbBundlePriceElement.classList.add('Disable');

                        singlePriceElement.classList.remove('Disable');
                        singleTitleElement.classList.remove('Disable');
                        affirm.classList.remove("Disable");
                        addToCartFormMobile.classList.remove("Disable");
                        addToCartForm.classList.remove("Disable")
                        ProductStickySinglePriceWrapper.classList.remove('Disable');
                        singleDescription.classList.remove('Disable');

                        stickyTitleElement.textContent = titleSingle;
                        addToBagMobile.textContent = "ADD TO CART - " + originalPrice;


                        // Rightbar single click remove inputs start
                        let inputsToRemoveDesktop = addToCartForm.querySelectorAll('.ProductInput');
                        inputsToRemoveDesktop.forEach(input => {
                            input.remove();
                        });

                        let inputsToRemoveMobile = addToCartFormMobile.querySelectorAll('.ProductInput');
                        inputsToRemoveMobile.forEach(input => {
                            input.remove();
                        });
                        // Rightbar single click remove inputs End

                    } else if (variant === 'bundle') {
                        affirmRefurb.classList.add("Disable");
                        affirm.classList.add("Disable");
                        addToCartFormRefurb.classList.add("Disable")
                        addToCartFormRefurbMobile.classList.add("Disable");
                        singleDescription.classList.add('Disable');
                        singleTitleElement.classList.add('Disable');
                        singlePriceElement.classList.add('Disable');
                        ProductStickySinglePriceWrapper.classList.add('Disable');

                        addToCartFormMobile.classList.remove("Disable");
                        addToCartForm.classList.remove("Disable")
                        bundleTitleElement.classList.remove('Disable');
                        bundlePriceElement.classList.remove('Disable');
                        ProductStickyBundlePriceWrapper.classList.remove('Disable');
                        bundleDescription.classList.remove('Disable');

                        stickyTitleElement.textContent = titleBundle;

                        var bundleElement = document.querySelector('.ProductStickyBundlePriceWrapper');
                        var bundleDiscount = bundleElement.getAttribute('data-bundle-discount');

                        if (bundleDiscount && bundleDiscount !== "blank") {
                            addToBagMobile.textContent = "ADD TO CART - " + bundlePrice;
                        } else {
                            addToBagMobile.textContent = "ADD TO CART - " + bundleDiscount;
                        }

                        refurbPriceElement.classList.add('Disable');
                        refurbTitleElement.classList.add('Disable');

                        ProductStickyRefurbSinglePriceWrapper.classList.add('Disable');
                        ProductStickyRefurbBundlePriceWrapper.classList.add('Disable');

                        refurbBundleTitleElement.classList.add('Disable');
                        refurbBundlePriceElement.classList.add('Disable');

                        let ProductInput = addToCartForm.querySelector('.ProductInput');
                        if (!ProductInput) {
                            appendProductInputs(addToCartForm, productId, planId);
                        }

                        let ProductInputMobile = addToCartFormMobile.querySelector('.ProductInput');
                        if (!ProductInputMobile) {
                            appendProductInputs(addToCartFormMobile, productId, planId);
                        }

                    } else if (variant === 'refurbsingle') {

                        affirm.classList.add("Disable");
                        bundleDescription.classList.add('Disable');
                        singleTitleElement.classList.add('Disable');
                        bundleTitleElement.classList.add('Disable');
                        singlePriceElement.classList.add('Disable');
                        bundlePriceElement.classList.add('Disable');
                        ProductStickySinglePriceWrapper.classList.add('Disable');
                        ProductStickyBundlePriceWrapper.classList.add('Disable');
                        addToCartForm.classList.add("Disable");
                        addToCartFormMobile.classList.add("Disable");
                        ProductStickyRefurbBundlePriceWrapper.classList.add('Disable');
                        refurbBundleTitleElement.classList.add('Disable');
                        refurbBundlePriceElement.classList.add('Disable');

                        singleDescription.classList.remove('Disable');
                        affirmRefurb.classList.remove("Disable");
                        addToCartFormRefurb.classList.remove("Disable");
                        addToCartFormRefurbMobile.classList.remove("Disable");
                        refurbPriceElement.classList.remove('Disable');
                        refurbTitleElement.classList.remove('Disable');
                        ProductStickyRefurbSinglePriceWrapper.classList.remove('Disable');
                        stickyTitleElement.textContent = titleRefurb;

                        if (addToBagMobileRefurb) {
                            if (addToBagMobileRefurb.disabled) {
                                addToBagMobileRefurb.textContent = "OUT OF STOCK - " + refurbPriceElement.textContent;
                            } else {
                                addToBagMobileRefurb.textContent = "ADD TO CART - " + refurbPriceElement.textContent;
                            }
                        }


                        let inputsToRemoveDesktop = addToCartFormRefurb.querySelectorAll('.ProductInput');
                        inputsToRemoveDesktop.forEach(input => {
                            input.remove();
                        });

                        let inputsToRemoveMobile = addToCartFormRefurbMobile.querySelectorAll('.ProductInput');
                        inputsToRemoveMobile.forEach(input => {
                            input.remove();
                        });

                    } else if (variant === 'refurbbundle') {

                        affirmRefurb.classList.add("Disable");
                        affirm.classList.add("Disable");
                        singleDescription.classList.add('Disable');
                        singleTitleElement.classList.add('Disable');
                        bundleTitleElement.classList.add('Disable');
                        singlePriceElement.classList.add('Disable');
                        bundlePriceElement.classList.add('Disable');
                        refurbPriceElement.classList.add('Disable');
                        refurbTitleElement.classList.add('Disable');
                        ProductStickySinglePriceWrapper.classList.add('Disable');
                        ProductStickyBundlePriceWrapper.classList.add('Disable');
                        ProductStickyRefurbSinglePriceWrapper.classList.add('Disable');
                        addToCartFormMobile.classList.add("Disable");
                        addToCartForm.classList.add("Disable");

                        stickyTitleElement.textContent = titleRefurbBundle;
                        ProductStickyRefurbBundlePriceWrapper.classList.remove('Disable');
                        refurbBundleTitleElement.classList.remove('Disable');
                        refurbBundlePriceElement.classList.remove('Disable');
                        bundleDescription.classList.remove('Disable');
                        addToCartFormRefurb.classList.remove("Disable");
                        addToCartFormRefurbMobile.classList.remove("Disable");

                        var refurbBundleElement = document.querySelector('.ProductStickyRefurbBundlePriceWrapper');
                        var refurbBundleDiscount = refurbBundleElement.getAttribute('data-bundle-refurb-discount');


                        if (refurbBundleDiscount && refurbBundleDiscount !== "blank") {
                            if (addToBagMobileRefurb) {
                                if (addToBagMobileRefurb.disabled) {
                                    addToBagMobileRefurb.textContent = "OUT OF STOCK - " + refurbBundleDiscount;
                                } else {
                                    addToBagMobileRefurb.textContent = "ADD TO CART - " + refurbBundleDiscount;
                                }
                            }

                        } else {
                            if (addToBagMobileRefurb.disabled) {
                                addToBagMobileRefurb.textContent = "OUT OF STOCK -" + bundlePrice;
                            } else {
                                addToBagMobileRefurb.textContent = "ADD TO CART -" + bundlePrice;
                            }
                        }


                        let ProductInput = addToCartFormRefurb.querySelector('.ProductInput');
                        if (!ProductInput) {
                            appendProductInputs(addToCartFormRefurb, productId, planId);
                        }

                        let ProductInputMobile = addToCartFormRefurbMobile.querySelector('.ProductInput');
                        if (!ProductInputMobile) {
                            appendProductInputs(addToCartFormRefurbMobile, productId, planId);
                        }
                    }
                });
            });
        } else if (productType === 'package') {
            var packageProduct = document.getElementById('product-info');
            if (packageProduct) {
                var bundleId = packageProduct.getAttribute('data-bundle-id');
                var bundlePrice = packageProduct.getAttribute('data-bundle-price');

                var priceSpan = document.querySelector('.sticky-product-price');
                var rightbarPriceSpan = document.querySelector('.RightbarProductSinglePrice .Text2');
                if (priceSpan) priceSpan.textContent = bundlePrice;
                if (rightbarPriceSpan) rightbarPriceSpan.textContent = bundlePrice;

                var addToBagMobilePackage = document.querySelector('.add-to-bag-mobile');
                if (addToBagMobilePackage) {
                    addToBagMobilePackage.textContent = `ADD TO CART - ${bundlePrice}`;
                }

                var addToCartForms = document.querySelectorAll('.add-to-cart-form, .add-to-cart-form-mobile');
                addToCartForms.forEach(function (form) {
                    var inputId = document.createElement('input');
                    inputId.setAttribute('type', 'hidden');
                    inputId.setAttribute('name', 'items[1][id]');
                    inputId.setAttribute('value', bundleId);
                    inputId.setAttribute('class', 'ProProductInput');

                    var inputQuantity = document.createElement('input');
                    inputQuantity.setAttribute('type', 'hidden');
                    inputQuantity.setAttribute('name', 'items[1][quantity]');
                    inputQuantity.setAttribute('value', '1');
                    inputQuantity.setAttribute('class', 'ProProductInput');

                    form.appendChild(inputId);
                    form.appendChild(inputQuantity);
                });
            } else {
                console.error('Product info element with ID "product-info" not found.');
            }
        }
    }
    // Product Rightbar Variation End

    // Product Page Load Click Start
    if (singleButton) {
        singleButton.click();
    }
    // Product Page Load Click End

    // Product Variations Start

    let selectedVariants = {};

    var formatMoney = (number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(number);
    };

    let productVariants = document.querySelectorAll('.ProductVariant');
    let swiperSlides = document.querySelectorAll('.ProductMainGallery .swiper-slide');
    let SubscriptionClickVariant = document.querySelector('.SubscriptionProduct');
    let subscriptionInput = document.querySelector('.ProductVariantSubsInput');

    productVariants.forEach(variant => {
        var priceCents = parseFloat(variant.getAttribute('data-price'));
        if (isNaN(priceCents)) {
            console.error('Error:', priceCents);
            return;
        }
        var price = priceCents / 100;
        var variantId = variant.getAttribute('data-variant-id');
        selectedVariants[variantId] = {quantity: 0, price: price};
        variant.addEventListener('click', () => {
            setActiveVariant(variant);
            updateSwiperAndGallery();

            if (SubscriptionClickVariant) {
                var stickyPrice = document.querySelector('.sticky-product-price');
                var subProductId = variant.getAttribute('data-variant-id');

                if (stickyPrice) {
                    stickyPrice.textContent = formatMoney(price);
                }
                if (subscriptionInput) {
                    subscriptionInput.value = subProductId;
                }

            }
        });

        setupQuantityButtons(variant, variantId);
    });

    function updateSwiperAndGallery() {
        swiper.update();
        let visibleSlidesCount = 0;
        swiper.slides.forEach(slide => {
            if (slide.offsetWidth > 0 && slide.offsetHeight > 0) {
                visibleSlidesCount++;
            }
        });

        var galleryNavWrapper = document.querySelector('.GalleryNavWrapper');
        if (galleryNavWrapper) {
            galleryNavWrapper.style.display = visibleSlidesCount === 1 ? 'none' : 'flex';
        }
    }


    function setupQuantityButtons(variant, variantId) {
        var quantityInputs = document.querySelectorAll('.ProductQuantityInput');

        productVariants.forEach((variant, variantIndex) => {
            const quantityInputs = variant.querySelectorAll('.ProductQuantityInput');

            quantityInputs.forEach((input, index) => {
                if (variantIndex === 0 && index === 0) {
                    input.value = 1;
                } else {
                    input.value = 0;
                }
            });
        });

        var plusButton = variant.querySelector('.plus-btn');
        if (plusButton) {
            plusButton.addEventListener('click', (event) => {
                event.stopPropagation();
                changeQuantity(variantId, 1);
            });
        }

        var minusButton = variant.querySelector('.minus-btn');
        if (minusButton) {
            minusButton.addEventListener('click', (event) => {
                event.stopPropagation();
                changeQuantity(variantId, -1);
            });
        }
    }

    function changeQuantity(variantId, change) {
        let currentValue = selectedVariants[variantId].quantity;
        let newValue = Math.max(currentValue + change, 0);
        selectedVariants[variantId].quantity = newValue;

        var variant = document.querySelector(`.ProductVariant[data-variant-id="${variantId}"]`);
        var quantityInput = variant.querySelector('.ProductQuantityInput');
        quantityInput.value = newValue;

        updateTotalPrice();
        setActiveVariant(variant);
    }

    var updateTotalPrice = () => {
        let totalPrice = 0;
        for (var variantId in selectedVariants) {
            var variant = selectedVariants[variantId];
            totalPrice += variant.quantity * variant.price;
        }
        var totalPriceElement = document.querySelector('.sticky-product-price');
        totalPriceElement.textContent = formatMoney(totalPrice);

        var mobileTotalPriceElement = document.querySelector('#mobileTotalPrice');
        if (mobileTotalPriceElement) {
            mobileTotalPriceElement.textContent = formatMoney(totalPrice);
        }

    };

    var form = document.querySelector('.add-to-cart-form-variant');
    var formMobile = document.querySelector('.add-to-cart-form-variant-mobile');

    form?.addEventListener('submit', (e) => {
        e.preventDefault();
        handleFormSubmit(form);
    });

    formMobile?.addEventListener('submit', (e) => {
        e.preventDefault();
        handleFormSubmit(formMobile);
    });

    function handleFormSubmit(formElement) {
        if (Object.keys(selectedVariants).every(key => selectedVariants[key].quantity === 0)) {
            setDefaultVariant();
        }
        updateFormInputs(formElement);
        formElement.submit();
    }

    function setDefaultVariant() {
        var firstVariant = document.querySelector('.ProductVariant');
        if (firstVariant) {
            var firstVariantId = firstVariant.getAttribute('data-variant-id');
            selectedVariants[firstVariantId].quantity = 1;
            updateTotalPrice();
        }
    }

    function updateFormInputs(formElement) {
        let existingInputs = formElement.querySelectorAll('input[type="hidden"]');
        existingInputs.forEach(input => input.remove());

        let index = 0;
        for (var [variantId, variantData] of Object.entries(selectedVariants)) {
            let variantInput = document.createElement("input");
            variantInput.setAttribute("type", "hidden");
            variantInput.setAttribute("name", `items[${index}][id]`);
            variantInput.setAttribute("value", variantId);
            formElement.appendChild(variantInput);

            let quantityInput = document.createElement("input");
            quantityInput.setAttribute("type", "hidden");
            quantityInput.setAttribute("name", `items[${index}][quantity]`);
            quantityInput.setAttribute("value", variantData.quantity);
            formElement.appendChild(quantityInput);

            index++;

        }
    }

    var setActiveVariant = (selectedVariant) => {
        productVariants.forEach(v => v.classList.remove('active'));
        selectedVariant.classList.add('active');
        const variantOrder = selectedVariant.getAttribute('data-variant-order');
        swiperSlides.forEach(slide => {
            const slideOrder = slide.getAttribute('data-variant-order');
            const slideVariant = slide.getAttribute('data-variant');
            if (slideVariant === 'default' || slideOrder === variantOrder) {
                slide.style.display = 'flex';
            } else {
                slide.style.display = 'none';
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        setDefaultVariant();
    });

    // Product Variations End

});





